import { create } from 'zustand';
import { combine } from 'zustand/middleware';

const defaultState = {
  gsk2: '',
  gsk3: '',
  location: '',
  et: '1',
  ip: '',
  areaCodeList: [] as { code: string; prefix: string }[],
  bid: '',
  clientId: undefined as string | undefined,
  entityId: undefined as string | undefined,
  socials: [] as string[],
};

export const useConfigStore = create(combine(defaultState, (set) => ({ setConfig: set })));
